module.exports = __webpack_public_path__ + "static/signature-9000-b194e5d5ac8dc037f1906abff2173039.jpg";